import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import ContentHeader from "@/dashboard/shared/components/ContentHeader";
import SettingsSidebar from "./SettingsSidebar";
import styled from "styled-components";

const ContentWithSidebarContainer = styled.div`
  display: flex;
`;

const ContentContainer = styled.div`
  width: 100%;
`;

const SettingsLayout = () => {
  return (
    <>
      <ContentHeader title={"Settings"} />
      <ContentWithSidebarContainer>
        <SettingsSidebar />
        <ContentContainer>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </ContentContainer>
      </ContentWithSidebarContainer>
    </>
  );
};

export default SettingsLayout;
